module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABCUlEQVRYhe2UMW7CMBSGf9vxAkKV2LJk6iW4QYb2AkhICGF6JaiRUIcqQy/QiROwcQKY2KNKDHHMggQd8lqs2F7yT2+w9D7975PZ7rAUiBgec3kH0AEAQBJ6YXF+eSrRy8CAAfs5Bgco635muZUAUNp+FvwEFpD3c3QHOgAvEq5O49wwriEAwY16GxbfTW+9NGCs0ABSAKmB0NRbXydIG+ZgAP9OdABnCd/3k9zwq2hJpRbPn42iUXFu4JdolhbNCwAeEM0XQCuJDkBKqLfT248mjVKjDyfRqJANmPpOtNpdNGcAtCQalWT9NcsNExocELJS89dN6zVT4SFqJgEQoOa/AKKmA4gOcAFzL0EuLozkpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/NB/second_signal_4.png
// module id = sq8p
// module chunks = 1